/**
     * @desc 铸造NFT
通过合约铸造NFT后，传入item的id，更新item的pending状态，pending=0：非pending，pending=1：pending
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/mintedNFT', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/mintedNFT', params);
}
